<template>
  <div class="bordered">{{'multi-input here'}}</div>
</template>

<script>
    import {abstractField} from "vue-form-generator";

    export default {
        created() {
            console.log('contitional multi-input created');
        },
        mixins: [abstractField],
        name: 'ConditionalMultiInput'
    }
</script>

<style lang="scss">
.bordered {
  border:2px solid #dadada;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/core/Form/Fields/ConditionalMultiInput.vue